import { Box } from "@mui/material";

const DatagridHeader = ({ align, children }) => (
  <Box sx={{ width: "100%", textAlign: align }}>
    {children}
  </Box>
);

export default DatagridHeader;
